// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2YDZb","box":"WorkspacesBox_box__2RhuG","node":"WorkspacesBox_node__1ocrR"};